'use strict';

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

module.exports = alphaComplex;

var delaunay = require('delaunay-triangulate');

var circumradius = require('circumradius');

function alphaComplex(alpha, points) {
  return delaunay(points).filter(function (cell) {
    var simplex = new Array(cell.length);

    for (var i = 0; i < cell.length; ++i) {
      simplex[i] = points[cell[i]];
    }

    return circumradius(simplex) * alpha < 1;
  });
}

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(alphaComplex, "alphaComplex", "/home/yatham/Dev_BHS_Portal/node_modules/alpha-complex/alpha.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();